export default "__VITE_ASSET__9hLDvQfI__"